import React, {useContext, useEffect, useState} from 'react';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import LOGO from 'assets/ActusIcone2025x1024.png';
import {getadmin, getfotoperfil, getnome, getparceiro} from 'functions/gettabconfig';
import {getNotificacao} from 'functions/getnotificacao';
import config from 'config';
import {CidadeContext} from 'services/cidade';
import SelectCidade from 'components/SelectCidade';
import CONFIRMACAO from 'components/confirmacao';
import './style.css';

function Menu() {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [logadop, setLogadop] = useState(false);
    const [logadoa, setLogadoa] = useState(false);
    const [notificacoes, setNotificacoes] = useState(0);
    const [activeSubmenu, setActiveSubmenu] = useState(null);
    const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
    
    const { cod_cidade, cidades, setCodCidade } = useContext(CidadeContext);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
            if (window.innerWidth > 768) {
                setIsExpanded(true); // Default expanded on desktop
            } else {
                setIsExpanded(false); // Default collapsed on mobile
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check

        const fetchData = async () => {
            setLogadop(getparceiro());
            setLogadoa(getadmin());
            try {
                const count = await getNotificacao();
                setNotificacoes(count);
            } catch (e) {
                setNotificacoes(0);
            }
        };
        fetchData();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isExpanded) {
            document.body.classList.add('sidebar-expanded');
        } else {
            document.body.classList.remove('sidebar-expanded');
        }
    }, [isExpanded]);

    const toggleSidebar = () => setIsExpanded((currentValue) => !currentValue);
    const toggleSubmenu = (menu) => {
        if (activeSubmenu === menu) {
            setActiveSubmenu(null);
        } else {
            setActiveSubmenu(menu);
            if (!isExpanded) setIsExpanded(true);
        }
    };

    const handleLogout = () => {
        setShowLogoutConfirm(false);
        localStorage.removeItem('eamigaconfig');
        navigate('/login');
    };

    const SalvarCidade = (e) => {
        setCodCidade(e.target.value);
    };

    const isActive = (path) => location.pathname === path ? 'active' : '';
    const isParentActive = (paths) => paths.some(path => location.pathname.startsWith(path)) ? 'active' : '';

    // Fecha o menu ao mudar de rota em dispositivos móveis
    useEffect(() => {
        if (isMobile) {
            setIsExpanded(false);
        }
    }, [location.pathname, isMobile]);

    return (
        <>
            {isMobile && (
                <div className="mobile-navbar">
                    <div className="mobile-logo" onClick={() => navigate('/')}>
                        <img src={LOGO} alt="Actus" />
                        <span>Actus</span>
                    </div>
                    <div className="mobile-actions">
                        <Link to="/notificacao" className="mobile-notif-btn">
                            <i className="fas fa-bell"></i>
                            {notificacoes > 0 && <span className="mobile-badge">{notificacoes}</span>}
                        </Link>
                        <button className="mobile-hamburger" onClick={toggleSidebar}>
                            <i className={`fas ${isExpanded ? 'fa-times' : 'fa-bars'}`}></i>
                        </button>
                    </div>
                </div>
            )}
            <div className={`sidebar ${isExpanded ? 'expanded' : 'collapsed'} ${isMobile && isExpanded ? 'mobile-open' : ''}`}>
                <div className="sidebar-header">
                    {isExpanded && (
                        <div className="sidebar-logo-container" onClick={() => navigate('/')}>
                            <img src={LOGO} alt="Actus" className="sidebar-logo-img" />
                            <span className="sidebar-logo-text">Actus</span>
                        </div>
                    )}
                    <button className="toggle-btn" onClick={toggleSidebar}>
                        <i className={`fas ${isExpanded ? 'fa-chevron-left' : 'fa-bars'}`}></i>
                    </button>
                </div>

                <div className="sidebar-content">
                    <nav className="menu-nav">
                        {/* Geral */}
                        <div className="menu-section">
                            <Link to="/" className={`menu-link ${isActive('/')}`}>
                                <i className="fas fa-home"></i>
                                {isExpanded && <span>Início</span>}
                            </Link>
                            <Link to="/turismo" className={`menu-link ${isActive('/turismo')}`}>
                                <i className="fas fa-map-marked-alt"></i>
                                {isExpanded && <span>Turismo</span>}
                            </Link>
                            <Link to="/notificacao" className={`menu-link ${isActive('/notificacao')}`}>
                                <div className="icon-badge-container">
                                    <i className="fas fa-bell"></i>
                                    {notificacoes > 0 && <span className="badge-dot">{notificacoes}</span>}
                                </div>
                                {isExpanded && <span>Notificações</span>}
                            </Link>
                        </div>

                        {/* Meu Menu */}
                        <div className="menu-section">
                            <button 
                                className={`menu-link submenu-trigger ${isParentActive(['/meu']) || activeSubmenu === 'meu' ? 'active' : ''}`}
                                onClick={() => toggleSubmenu('meu')}
                            >
                                <i className="fas fa-user-circle"></i>
                                {isExpanded && <span>Minha Conta</span>}
                                {isExpanded && <i className={`fas fa-chevron-down arrow ${activeSubmenu === 'meu' ? 'open' : ''}`}></i>}
                            </button>
                            {(activeSubmenu === 'meu' || (isExpanded && isParentActive(['/meu']))) && (
                                <div className="submenu">
                                    <Link to="/meu/conquista" className={`submenu-link ${isActive('/meu/conquista')}`}>
                                        <i className="fas fa-medal"></i>
                                        {isExpanded && <span>Minhas Conquistas</span>}
                                    </Link>
                                    <Link to="/meu/participantes" className={`submenu-link ${isActive('/meu/participantes')}`}>
                                        <i className="fas fa-users"></i>
                                        {isExpanded && <span>Participantes</span>}
                                    </Link>
                                    <Link to="/meu/sorteados" className={`submenu-link ${isActive('/meu/sorteados')}`}>
                                        <i className="fas fa-trophy"></i>
                                        {isExpanded && <span>Sorteados</span>}
                                    </Link>
                                    <Link to="/meu/extrato" className={`submenu-link ${isActive('/meu/extrato')}`}>
                                        <i className="fas fa-list-alt"></i>
                                        {isExpanded && <span>Extrato</span>}
                                    </Link>
                                </div>
                            )}
                        </div>

                        {/* Parceiro */}
                        {logadop && (
                            <div className="menu-section">
                                <button 
                                    className={`menu-link submenu-trigger ${isParentActive(['/parceiro']) || activeSubmenu === 'parceiro' ? 'active' : ''}`}
                                    onClick={() => toggleSubmenu('parceiro')}
                                >
                                    <i className="fas fa-handshake"></i>
                                    {isExpanded && <span>Parceiro</span>}
                                    {isExpanded && <i className={`fas fa-chevron-down arrow ${activeSubmenu === 'parceiro' ? 'open' : ''}`}></i>}
                                </button>
                                {(activeSubmenu === 'parceiro' || (isExpanded && isParentActive(['/parceiro']))) && (
                                    <div className="submenu">
                                        <Link to="/parceiro/vender" className={`submenu-link ${isActive('/parceiro/vender')}`}>
                                            <i className="fas fa-shopping-cart"></i>
                                            {isExpanded && <span>Vender</span>}
                                        </Link>
                                        <Link to="/parceiro/aprovaavaliacao" className={`submenu-link ${isActive('/parceiro/aprovaavaliacao')}`}>
                                            <i className="fas fa-check-double"></i>
                                            {isExpanded && <span>Avaliações</span>}
                                        </Link>
                                        <Link to="/admin/estabelecimento" className={`submenu-link ${isActive('/admin/estabelecimento')}`}>
                                            <i className="fas fa-store"></i>
                                            {isExpanded && <span>Estabelecimento</span>}
                                        </Link>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Admin */}
                        {logadoa && (
                            <div className="menu-section">
                                <button 
                                    className={`menu-link submenu-trigger ${isParentActive(['/admin']) || activeSubmenu === 'admin' ? 'active' : ''}`}
                                    onClick={() => toggleSubmenu('admin')}
                                >
                                    <i className="fas fa-user-shield"></i>
                                    {isExpanded && <span>Administração</span>}
                                    {isExpanded && <i className={`fas fa-chevron-down arrow ${activeSubmenu === 'admin' ? 'open' : ''}`}></i>}
                                </button>
                                {(activeSubmenu === 'admin' || (isExpanded && isParentActive(['/admin']))) && (
                                    <div className="submenu">
                                        <Link to="/admin/home" className={`submenu-link ${isActive('/admin/home')}`}>
                                            <i className="fas fa-chart-line"></i>
                                            {isExpanded && <span>Dashboard</span>}
                                        </Link>
                                        <Link to="/admin/aprovaavaliacao" className={`submenu-link ${isActive('/admin/aprovaavaliacao')}`}>
                                            <i className="fas fa-check-double"></i>
                                            {isExpanded && <span>Avaliações</span>}
                                        </Link>
                                        <Link to="/admin/vender" className={`submenu-link ${isActive('/admin/vender')}`}>
                                            <i className="fas fa-shopping-cart"></i>
                                            {isExpanded && <span>Vender</span>}
                                        </Link>
                                        <Link to="/admin/campanha" className={`submenu-link ${isActive('/admin/campanha')}`}>
                                            <i className="fas fa-bullhorn"></i>
                                            {isExpanded && <span>Campanhas</span>}
                                        </Link>
                                        <Link to="/admin/estabelecimento" className={`submenu-link ${isActive('/admin/estabelecimento')}`}>
                                            <i className="fas fa-store"></i>
                                            {isExpanded && <span>Estabelecimentos</span>}
                                        </Link>
                                        <Link to="/admin/contemplado" className={`submenu-link ${isActive('/admin/contemplado')}`}>
                                            <i className="fas fa-award"></i>
                                            {isExpanded && <span>Contemplados</span>}
                                        </Link>
                                        <Link to="/admin/notificacao" className={`submenu-link ${isActive('/admin/notificacao')}`}>
                                            <i className="fas fa-paper-plane"></i>
                                            {isExpanded && <span>Notificações</span>}
                                        </Link>
                                        <Link to="/admin/aviso" className={`submenu-link ${isActive('/admin/aviso')}`}>
                                            <i className="fas fa-exclamation-triangle"></i>
                                            {isExpanded && <span>Avisos</span>}
                                        </Link>
                                        <Link to="/admin/promocoes" className={`submenu-link ${isActive('/admin/promocoes')}`}>
                                            <i className="fas fa-tag"></i>
                                            {isExpanded && <span>Promoções</span>}
                                        </Link>
                                        <Link to="/admin/turismo" className={`submenu-link ${isActive('/admin/turismo')}`}>
                                            <i className="fas fa-map-signs"></i>
                                            {isExpanded && <span>Turismo</span>}
                                        </Link>
                                        <Link to="/admin/cashback" className={`submenu-link ${isActive('/admin/cashback')}`}>
                                            <i className="fas fa-coins"></i>
                                            {isExpanded && <span>Cashback</span>}
                                        </Link>
                                    </div>
                                )}
                            </div>
                        )}
                    </nav>
                </div>

                <div className="sidebar-footer">
                    {logadoa && isExpanded && (
                        <div className="city-selector-sidebar">
                            <label><i className="fas fa-city me-2"></i>Cidade:</label>
                            <SelectCidade
                                cod_cidade={cod_cidade}
                                SalvarCidade={SalvarCidade}
                                cidades={cidades}
                                className="form-select form-select-sm"
                            />
                        </div>
                    )}

                    <div className="user-info">
                        <div className="user-avatar">
                            {getfotoperfil() ? (
                                <img 
                                    src={getfotoperfil().startsWith('http') ? getfotoperfil() : `${config.BASEIMG}${getfotoperfil()}`} 
                                    alt="Avatar" 
                                />
                            ) : (
                                <i className="fas fa-user"></i>
                            )}
                        </div>
                        {isExpanded && (
                            <div className="user-details">
                                <span className="user-name">{getnome() || 'Usuário'}</span>
                            </div>
                        )}
                        <button className="logout-icon-btn" onClick={() => setShowLogoutConfirm(true)} title="Sair">
                            <i className="fas fa-sign-out-alt"></i>
                        </button>
                    </div>
                </div>
            </div>

            <CONFIRMACAO
                trigger={showLogoutConfirm}
                setTrigger={setShowLogoutConfirm}
                title="Sair"
                message="Deseja realmente sair?"
                onConfirma={handleLogout}
            />

            {isMobile && isExpanded && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}
        </>
    );
}

export default Menu;
